import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "@/plugins/vuetify";
import { loadFonts } from "@/plugins/webfontloader";
import axios from "axios";
import router from "./router";
import store from "@/store";
import "@/axiosInterceptor";

import "@/assets/Fonts/PtSans.css";
import "@/assets/Fonts/Mulish.css";
import "@/assets/Fonts/Inter.css";
import "@/assets/Fonts/Roboto.css";
import "@/assets/Fonts/Outfit.css";
import "./assets/styles/variable.css";
import "./assets/styles/tokens.css";
import "./assets/styles/responsive.css";
import "./assets/styles/chrome.css";
import "./assets/styles/auth.css";
import "./assets/styles/common.css";
import "./assets/styles/plots.css";
import "./assets/styles/modules/data-management.css";
import "./assets/styles/modules/qaqc.css";
import "./assets/styles/modules/studio.css";
import "./assets/styles/modules/dashboards.css";
import "./assets/styles/modules/intelligence.css";
import "./assets/styles/modules/eda.css";
import "./assets/styles/modules/agentic.css";
import "./assets/styles/modules/settings.css";
import "./assets/styles/modules/aiml.css";
import "./assets/styles/modules/ocr.css";
import "./assets/styles/tables.css";
import "./assets/styles/drawers.css";
import "./assets/styles/dark-mode.css";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

document.documentElement.classList.add("fd-next");

loadFonts();

store.dispatch("test/initializeActiveTestIndex");
store.dispatch("darkMode/initializeDarkMode");

const app = createApp(App);
app.use(vuetify);
app.use(router);
app.use(store);
app.component("VueDatePicker", VueDatePicker);
app.mount("#app");

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
